import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import CreateProject from './pages/create-project';
import ClientPreview from './pages/client-preview';
import DigitalVault from './pages/digital-vault';
import Login from './pages/login';
import SignUp from './pages/signup';
import Dashboard from './pages/dashboard';
import FeedbackDashboard from './pages/feedback-dashboard';
import TeamManagement from './pages/team-management';
import ProfileEdit from './pages/profile-edit';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<Dashboard />} />
        <Route path="/new-quote" element={<CreateProject />} />
        <Route path="/client-preview/:previewId" element={<ClientPreview />} />
        <Route path="/client-preview" element={<ClientPreview />} />
        <Route path="/digital-vault" element={<DigitalVault />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/feedback-dashboard" element={<FeedbackDashboard />} />
        <Route path="/team-management" element={<TeamManagement />} />
        <Route path="/profile-edit" element={<ProfileEdit />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;